import React from "react";
import MenuItem from '@mui/material/MenuItem';
import { TextField } from "@mui/material";
import { PutProductDistributorOfferingStatus, PutProductDistributorFulfillmentType } from "../hooks/useFetchProductSettingsDistributorOverrides";
import { useSKUOfferingStatusesContext } from "../../../Contexts/skuOfferingStatusesContext";
import { useProductSettingsContext } from "../context/ProductSettingsContext";
import PropTypes from 'prop-types';
import { SkuOfferingStatus } from "../../../Enums/SkuOfferingStatus";

export const SkuOfferingStatusSelect = ({
    row,
    originalRow,
    handleUpdateRow,
}) => {
    const { skuOfferingStatuses } = useSKUOfferingStatusesContext();
    const { getPossibleSkuFulfillmentTypes, fulfillmentMethodMappings } = useProductSettingsContext();

    const updateProductDistributorOfferingStatus = async (distributorRow, originalRow) => {
        const offeringStatusChanged = distributorRow.skuOfferingStatus?.id !== originalRow?.skuOfferingStatus?.id;
        const fulfillmentTypeChanged = distributorRow.skuFulfillmentType?.id !== originalRow?.skuFulfillmentType?.id;

        if (offeringStatusChanged || fulfillmentTypeChanged) {
            if (offeringStatusChanged) {
                await PutProductDistributorOfferingStatus(distributorRow.product, distributorRow);
            }

            if (fulfillmentTypeChanged) {
                await PutProductDistributorFulfillmentType(distributorRow.product, distributorRow);
            }
        }

        if (distributorRow.skuFulfillmentType && distributorRow.skuFulfillmentType.id) {
            await PutProductDistributorFulfillmentType(distributorRow.product, distributorRow);
        }
    };

    return (<TextField
        select
        value={row.skuOfferingStatus?.id ?? SkuOfferingStatus.NOT_OFFERED}
        size="small"
        fullWidth
        onChange={async (event) => {
            const newOfferingStatus = event.target.value;
            const possibleFulfillmentTypes = getPossibleSkuFulfillmentTypes(row.type, newOfferingStatus);

            // Check if current fulfillment method is valid for the new offering status
            const isCurrentFulfillmentTypeValid = possibleFulfillmentTypes.skuFulfillmentTypes.some(
                type => type.id === row.skuFulfillmentType?.id
            );

            let newFulfillmentType;
            if (isCurrentFulfillmentTypeValid) {
                // Keep the current fulfillment method if it's valid
                newFulfillmentType = row.skuFulfillmentType;
            } else {
                // Find the default fulfillment method for this combination
                const defaultMapping = fulfillmentMethodMappings.find(mapping =>
                    mapping.customerType === row.type &&
                    mapping.offeringStatus === newOfferingStatus &&
                    mapping.isDefault
                );

                if (defaultMapping) {
                    newFulfillmentType = {
                        id: defaultMapping.fulfillmentType,
                        description: defaultMapping.fulfillmentTypeDescription
                    };
                } else {
                    // Fallback to first available option if no default found
                    newFulfillmentType = possibleFulfillmentTypes.skuFulfillmentTypes[0];
                }
            }

            const tempRow = {
                ...row,
                skuOfferingStatus: skuOfferingStatuses.find(status => status.id === newOfferingStatus),
                skuFulfillmentType: newFulfillmentType
            };

            await updateProductDistributorOfferingStatus(tempRow, originalRow);
            await handleUpdateRow(tempRow);
        }}
    >
        {skuOfferingStatuses?.map(status => <MenuItem key={status.id}
            value={status.id}>
            {status.description}
        </MenuItem>)}
    </TextField>

    );
}

SkuOfferingStatusSelect.propTypes = {
    handleUpdateRow: PropTypes.func,
    row: PropTypes.object,
    originalRow: PropTypes.object
}